import { render } from "./SectionButton.vue?vue&type=template&id=73b616c4&scoped=true"
import script from "./SectionButton.vue?vue&type=script&lang=js"
export * from "./SectionButton.vue?vue&type=script&lang=js"

import "./SectionButton.vue?vue&type=style&index=0&id=73b616c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b616c4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
